import { useMemo } from "react"
import { UserData, useUserStore } from "@/lib/fetch-users"

function useUserData(userName: string | null | undefined, returnMissingUser: boolean = true) {
  const users = useUserStore((state) => state.users)

  const user = useMemo<UserData | null>((): UserData | null => {
    if (!userName) {
      return null
    }

    if (!users) {
      return {
        userName: userName,
        firstName: "Loading user...",
        lastName: "",
        role: "NONE",
        professionalTitle: "NONE",
        roleData: null,
        globalLocationNumber: null,
        isDeleted: false,
        acsUserId: null,
      }
    }

    const user = users.get(userName)

    if (returnMissingUser && !user) {
      return {
        userName: userName,
        firstName: "Missing",
        lastName: "Missing",
        role: "NONE",
        professionalTitle: "NONE",
        roleData: null,
        globalLocationNumber: null,
        isDeleted: false,
        acsUserId: null,
      }
    }

    if (!user) {
      return {
        userName: userName,
        firstName: userName,
        lastName: "",
        role: "NONE",
        professionalTitle: "NONE",
        roleData: null,
        globalLocationNumber: null,
        isDeleted: false,
        acsUserId: null,
      }
    }

    if (!user.firstName && !user.lastName) {
      return {
        userName: userName,
        firstName: "Unknown",
        lastName: "Unknown",
        role: "NONE",
        professionalTitle: "NONE",
        roleData: null,
        globalLocationNumber: null,
        isDeleted: false,
        acsUserId: null,
      }
    }

    return user
  }, [userName, users, returnMissingUser])

  return user
}

export { useUserData }
